import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Col, Row, FormGroup, Input } from 'reactstrap';
import ReactPaginate from 'react-paginate';
import _ from 'lodash'
import api from '../../api';
import utils from '../../resources/utils';
import DataRow from '../../components/DataRow';
import Segment from '../../components/Segment';
import './index.css';

// The Roster component matches one of two different routes
// depending on the full pathname
export default class SegmentsScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            segments: [],
            segmentsCount: 0,
            pagesCount: 0,
            page: 1,
            limit: 10,
            isLoading: false,
            searchKeyword: '',
        }
        this.searchSegment = _.debounce(this.getSegments, 300);
    }
    componentWillMount() {
        this.getSegments(1);
    }
    componentDidMount = () => {
        
    }
    buildSearchKeyword(text) {
        this.setState({ searchKeyword: text }, () => this.searchSegment(1));
    }
    async getSegments(pageNumber) {
        if (!pageNumber) return;
        await this.setState({ page: pageNumber });
        const { page, limit, searchKeyword } = this.state;
        let uri = `segments?`;
        if (searchKeyword) {
            uri = `segments/search?q=${searchKeyword}&`;
        }
        uri = `${uri}page=${page}&limit=${limit}&order_by=created_at&order_type=descending`;
        api.fetchAPI({
            method: 'get',
            uri,
            success: (response) => {
                console.log(response);
                this.setState({
                    segments: response.segments,
                    segmentsCount: response._query.total,
                    pagesCount: response._query.total_pages,
                });
                this.setState({ isLoading: false });
            },
            error: (error) => {
              console.error(error);
              this.setState({ isLoading: false });
            }
        });
    }
    render() {
        const { segments, pagesCount, searchKeyword } = this.state;
        return (
            <div className="page-container">
                <Row>
                    <Col xs={12}>
                        <h1>Segments</h1>
                    </Col>
                    <Col xs={12}>
                        <Button color="success" tag={Link} to="/segments/create">Create</Button>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <br />
                        <FormGroup>
                            <Input
                                type="text"
                                placeholder="Search for something..."
                                value={searchKeyword}
                                onChange={(e) => this.buildSearchKeyword(e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                    {pagesCount && pagesCount > 0 &&
                        <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'...'}
                            breakClassName={'break-me'}
                            pageCount={pagesCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            initialPage={0}
                            onPageChange={page => this.getSegments(page.selected + 1)}
                            containerClassName={'pagination'}
                            subContainerClassName={'pages pagination'}
                            activeClassName={'active'}
                        />
                    }
                    </Col>
                </Row>
                <Row>
                    {segments.map(segment => 
                        <Col key={segment.id} xs={12} sm={6} md={4}>
                            <Segment segment={segment} />
                        </Col>
                    )}
                </Row>
            </div>
        );
    };
}



// WEBPACK FOOTER //
// ./src/pages/Segments/index.js